import { Enum } from 'typescript-string-enums';

import { SelectOption } from '../../shared/dynamic-form/shared/question-select-option';

export const Status = Enum('READY', 'INPROGRESS', 'CLOSE');
export type Status = Enum<typeof Status>;

export class CourseLectureStatus {
  static Status = Status;

  static getOptions(status: Status): SelectOption[] {
    const options: SelectOption[] = [];

    const keys = Enum.keys(Status);

    keys.forEach(key => {
      if (status === undefined) {
        options.push(new SelectOption(Status.INPROGRESS, Status.INPROGRESS, true));
      } else if (key === status) {
        options.push(new SelectOption(key, key, true));
      } else {
        options.push(new SelectOption(key, key));
      }
    });
    return options;
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/shared/base/course-lecture-status.ts